import React from 'react'

export type Props = {
  children: React.ReactNode
}

export const UspIcon = ({ children }: Props) => (
  <div className='w-12 h-12 mb-3'>{children}</div>
)
